
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="body 列合并" fileName="body-colspan.md" />
        <demo-block>
        <div><p>设置第 2 行<code>date</code>列和<code>hoby</code>列合并。 同时需要指定第 2 行<code>hoby</code>列不渲染</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table
        :columns=&quot;columns&quot;
        :table-data=&quot;tableData&quot;
        :border-around=&quot;true&quot;
        :border-x=&quot;true&quot;
        :border-y=&quot;true&quot;
        :cell-span-option=&quot;cellSpanOption&quot;
    /&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                cellSpanOption: {
                    bodyCellSpan: this.bodyCellSpan,
                },
                columns: [
                    {
                        field: &quot;name&quot;,
                        key: &quot;a&quot;,
                        title: &quot;Name&quot;,
                        width: 200,
                        align: &quot;center&quot;,
                    },
                    {
                        field: &quot;date&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Date&quot;,
                        width: 200,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        width: 200,
                        align: &quot;right&quot;,
                    },
                    { field: &quot;address&quot;, key: &quot;d&quot;, title: &quot;Address&quot;, width: &quot;&quot; },
                ],
                tableData: [
                    {
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                    },
                ],
            };
        },
        methods: {
            // body cell span
            bodyCellSpan({ row, column, rowIndex }) {
                if (rowIndex === 1) {
                    if (column.field === &quot;date&quot;) {
                        return {
                            rowspan: 1,
                            colspan: 2,
                        };
                    }
                    // does not need to be rendered
                    else if (column.field === &quot;hobby&quot;) {
                        return {
                            rowspan: 0,
                            colspan: 0,
                        };
                    }
                }
            },
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData,"border-around":true,"border-x":true,"border-y":true,"cell-span-option":_vm.cellSpanOption}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                cellSpanOption: {
                    bodyCellSpan: this.bodyCellSpan,
                },
                columns: [
                    {
                        field: "name",
                        key: "a",
                        title: "Name",
                        width: 200,
                        align: "center",
                    },
                    {
                        field: "date",
                        key: "b",
                        title: "Date",
                        width: 200,
                        align: "left",
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        width: 200,
                        align: "right",
                    },
                    { field: "address", key: "d", title: "Address", width: "" },
                ],
                tableData: [
                    {
                        name: "John",
                        date: "1900-05-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shanghai",
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Beijing",
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                    },
                ],
            };
        },
        methods: {
            // body cell span
            bodyCellSpan({ row, column, rowIndex }) {
                if (rowIndex === 1) {
                    if (column.field === "date") {
                        return {
                            rowspan: 1,
                            colspan: 2,
                        };
                    }
                    // does not need to be rendered
                    else if (column.field === "hobby") {
                        return {
                            rowspan: 0,
                            colspan: 0,
                        };
                    }
                }
            },
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  